import { render } from "./familyHome.vue?vue&type=template&id=80edda7e&scoped=true"
import script from "./familyHome.vue?vue&type=script&lang=js"
export * from "./familyHome.vue?vue&type=script&lang=js"

import "./familyHome.vue?vue&type=style&index=0&id=80edda7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80edda7e"]])

export default __exports__